export default __webpack_public_path__ + "static/Top-Slant-76f21a0a54b2a8e87d927b46b6929ff2.png";